import React from 'react';

import { Segmented } from 'antd';

import styled from 'styled-components';

import CitySelectorMulti from '@components/CitySelectorMulti/CitySelectorMulti';
import ContactDropdown from '@components/ContactDropdown/ContactDropdown';
import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import { FilterRow, FilterLabel, FilterWrapper } from '@components/Filters/FilterRowUI';
import NwDivider from '@components/Gui/NwDivider';
import { AgencyTypeSelector } from '@components/Gui/NwForm/AgencyTypeSelector';
import BooleanSelector from '@components/Gui/NwForm/BooleanSelector';
import FilterClearButton from '@components/Gui/NwForm/FilterClearButton';
import SelectCountry from '@components/Gui/NwForm/SelectCountry';

const Wrapper = styled.div``;

const FieldWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
`;

const ModelFilterDrawerAgencySection = ({ section }) => {
    const { selection } = useContactsSelector();
    const cs_dispatch = useContactsSelectorDispatch();
    const { filters } = selection;

    //specific method for represented
    //should remove the filter if the value is null or set true or false
    const handleRepresentedChange = (val) => {
        let newWorkingFilters = [...filters.working];
        const filterIndex = newWorkingFilters.findIndex((f) => f.name === 'Represented');
        if (val === null) {
            if (filterIndex !== -1) {
                newWorkingFilters.splice(filterIndex, 1);
            }
        } else {
            if (filterIndex === -1) {
                newWorkingFilters.push({ name: 'Represented', value: val, source: 'filter' });
            } else {
                newWorkingFilters[filterIndex].value = val;
            }
        }
        cs_dispatch({ type: 'ChangeFilters', filters: newWorkingFilters });
    };

    const handleChangeFilterValue = (name, val, isBoolean = false) => {
        const filter = section.areaFilters.find((f) => f.name === name);
        let newWorkingFilters = [...filters.working];
        const filterIndex = newWorkingFilters.findIndex((f) => f.name === name);

        if (val || (isBoolean && val !== null)) {
            if (filterIndex === -1) {
                newWorkingFilters.push({ name: filter.name, value: val, source: 'filter' });
            } else {
                newWorkingFilters[filterIndex].value = val;
            }
        } else {
            if (filterIndex !== -1) {
                newWorkingFilters.splice(filterIndex, 1);
            }
        }
        if (name === 'AgencyNotIn' && val === true) {
            newWorkingFilters = newWorkingFilters.filter((f) => f.name !== 'AgencyID');
        }
        cs_dispatch({ type: 'ChangeFilters', filters: newWorkingFilters });
    };

    const getFilterValue = (name) => {
        const filter = section.areaFilters.find((f) => f.name === name);
        let filterValue = filter.defaultval;
        const workingFilter = filters.working.find((f) => f.name === filter.name);
        if (workingFilter) {
            filterValue = workingFilter.value;
        }
        return filterValue;
    };

    const isFilterActive = (name) => {
        const filter = filters.working.find((f) => f.name === name);
        if (filter) {
            return true;
        }
        return false;
    };

    let currentValueForNotIn = getFilterValue('AgencyNotIn');
    if (typeof currentValueForNotIn === 'undefined' || currentValueForNotIn === null) {
        currentValueForNotIn = false;
    }

    return (
        <Wrapper>
            <FilterRow>
                <FilterLabel>Include only models:</FilterLabel>
                <FilterWrapper>
                    <Segmented
                        value={currentValueForNotIn}
                        options={[
                            {
                                label: 'With',
                                value: false,
                            },
                            {
                                label: 'Without',
                                value: true,
                            },
                        ]}
                        onChange={(value) => handleChangeFilterValue('AgencyNotIn', value)}
                    />
                </FilterWrapper>
            </FilterRow>
            {!currentValueForNotIn && (
                <FilterRow>
                    <FilterLabel className={isFilterActive('AgencyID') ? 'active' : ''}>Agency:</FilterLabel>
                    <FilterWrapper>
                        <ContactDropdown
                            activeTypes={['age']}
                            value={getFilterValue('AgencyID')}
                            onChange={(value) => handleChangeFilterValue('AgencyID', value)}
                        />
                    </FilterWrapper>
                </FilterRow>
            )}
            <FilterRow>
                <FilterLabel className={isFilterActive('AgencyType') ? 'active' : ''}>Agency Type:</FilterLabel>
                <FilterWrapper>
                    <AgencyTypeSelector
                        value={getFilterValue('AgencyType')}
                        onChange={(value) => handleChangeFilterValue('AgencyType', value)}
                        emptyValue
                    />
                </FilterWrapper>
            </FilterRow>
            <FilterRow>
                <FilterLabel className={isFilterActive('AgencyCities') ? 'active' : ''}>Agency Cities:</FilterLabel>
                <FilterWrapper>
                    <CitySelectorMulti
                        value={getFilterValue('AgencyCities')}
                        onChange={(value) => handleChangeFilterValue('AgencyCities', value)}
                        emptyValue
                    />
                </FilterWrapper>
            </FilterRow>
            <FilterRow>
                <FilterLabel className={isFilterActive('AgencyCountry') ? 'active' : ''}>Agency Country:</FilterLabel>
                <FilterWrapper>
                    <SelectCountry
                        value={getFilterValue('AgencyCountry')}
                        onChange={(value) => handleChangeFilterValue('AgencyCountry', value)}
                        emptyValue
                    />
                </FilterWrapper>
            </FilterRow>
            <FilterRow>
                <FilterLabel className={isFilterActive('AgencyIncludeDropped') ? 'active' : ''}>
                    Include Dropped:
                </FilterLabel>
                <FilterWrapper>
                    <FieldWrapper>
                        <BooleanSelector
                            emptyValue
                            value={getFilterValue('AgencyIncludeDropped')}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            onChange={(value) => {
                                handleChangeFilterValue('AgencyIncludeDropped', value, true);
                            }}
                        />
                    </FieldWrapper>
                </FilterWrapper>
            </FilterRow>
            <br />
            <NwDivider>Represented Status</NwDivider>
            <br />
            <FilterRow>
                <FilterLabel className={isFilterActive('Represented') ? 'active' : ''}>Represented:</FilterLabel>
                <FilterWrapper>
                    <FieldWrapper>
                        <BooleanSelector
                            emptyValue
                            value={getFilterValue('Represented')}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            onChange={(value) => {
                                handleRepresentedChange(value);
                            }}
                        />
                        <FilterClearButton onClick={() => handleRepresentedChange(null)} />
                    </FieldWrapper>
                </FilterWrapper>
            </FilterRow>
        </Wrapper>
    );
};

export default ModelFilterDrawerAgencySection;
